<template>
  <div>
    <admin-simple-table :field_list="tableData"
                        :items="tableItems"
                        :filtered="filtered"
                        :allCount="allCount"
                        :filteredCount="filteredCount"
                        :table_width="600"
                        @getData="getDataFromServer"
                        @ordering="ordering"
                        @selPageLength="selPageLength">

     <!-- <div slot="checkspot" slot-scope="props" v-if="isAdmin">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>-->

      <div slot="status" slot-scope="props">
        {{ approveStatus(props.item.status) }}
      </div>

      <div slot="product" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <a :href="getPath(`product/create?id=${props.item.product_id}`)" target="_blank"><span>{{ props.item.product }}</span></a>
      </div>

      <!--<div slot="spot" v-if="tableItems.length > 0 && isAdmin">
        <div style="background-color: #eee; padding: 8px">
          <button class="button is-primary" @click="clickApproval('approval')">선택 승인</button>
          <button class="button" @click="clickApproval('unapproval')">선택 미승인</button>
        </div>
      </div>-->

    </admin-simple-table>

    <modal name="approveCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-form-item label="미승인 사유">
           <textarea class="textarea"
                     rows="10"
                     cols="10"
                     placeholder="미승인 사유를 메모로 남겨주세요."
                     v-model="memo"></textarea>
        </admin-form-item>

        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveModal">저장</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {

    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    data () {
      return {
        // 선택된 체크박스
        checkArr: [],
        memo: ''
      }
    },

    created(){
      this.initializing('product_approval_all', 'product/approval');
      if(this.isInternalPlugin('partner_grade'))
        this.tableData.splice(4, 0, {width: '80px', ko_name: '파트너 등급', eng_name: 'partner_grade'});

      /*for(let i=0; i<this.tableData.length; i++){
        if(this.tableData[i].eng_name === 'checkspot') {
          removeIndex(this.tableData,i);
          break;
        }
      }*/
    },
    methods: {
      clickProd(product_id) {
        this.$router.push(this.getPath(`product/create?id=${product_id}`))
      },
      // 아이템 하나 선택 했을 경우
      clickApprovalOne(type, item){
        if( type === 'approval') {
          this.$axios.post(this.getUrl('product/approval/'+item.id), {
            type: 'approval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('승인 완료되었습니다');
              this.getData();
            }
          }).catch(error=>{
            if(error.response){
              this.toast(error.response.detail);
            }
          })
        }
        else if( type === 'unapproval') {
          this.$axios.post(this.getUrl('product/approval'+item.id), {
            type: 'unapproval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('미승인 완료되었습니다');
              this.getData();
            }
          })
        }
      },

      saveModal() {
        let id_list = this.getCheckedArr();
        if(id_list.length===0){
          return;
        }

        this.$axios.post(this.getUrl('product/approval/multiple'), {
          approvals: id_list,
          type: 'unapproval',
          memo: this.memo
        }).then(res=>{
          if(res.status===200) {
            this.toast('미승인 완료되었습니다');
            this.getData();
            this.$modal.hide('approveCancelModal');
            this.memo = '';
          }
        })
      },


      // 체크박스로 다수 선택 하고 호출할 경우
      clickApproval(type){
        if( type === 'approval') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0){
            return;
          }

          this.$axios.post(this.getUrl('product/approval/multiple'), {
            approvals: id_list,
            type: 'approval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('승인 완료되었습니다');
              this.getData();
            }
          }).catch(error=>{
            if(error.response){
              this.toast(error.response.detail);
            }
          })
        }
        else if( type === 'unapproval') {
          this.$modal.show('approveCancelModal');
        }
      },

      //  체크된 id들 가져오기
      getCheckedArr(){
        let id_list = [];
        for(let i=0; i<this.checkArr.length; i++){
          if(this.checkArr[i].value){
            id_list.push(this.checkArr[i].id);
          }
        }

        return id_list;
      },

      getData() {
        this.$axios.get(this.getUrl('product/approval'), {
          params: this.filtered
        }).then(res=>{
          if (res.status === 200) {
            // console.log(res)
            this.tableItems = res.data.data;
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;

            let tableList = [];
            for(let i=0; i<this.tableItems.length; i++){
              tableList.push ({id: this.tableItems[i].id, value: false});
            }
            this.checkArr = tableList;
          }
        })
      },
      approveStatus(status) {
        if (status===0) return '요청';
        else if (status===1) return '미승인';
        else if (status===2) return '승인';
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
